export interface stadiumInfo {
  id: number;
  azimuth: number;
  latitude: number;
  longitude: number;
}

export const geolocations = [
  {
    id: 1,
    azimuth: 43.61,
    latitude: 33.799924,
    longitude: -117.883175,
  },
  {
    id: 15,
    azimuth: 0,
    latitude: 33.445066237,
    longitude: -112.066705563,
  },
  {
    id: 4705,
    azimuth: 155,
    latitude: 33.891120559,
    longitude: -84.467885574,
  },
  {
    id: 2,
    azimuth: 31,
    latitude: 39.283516216,
    longitude: -76.62191439,
  },
  {
    id: 3,
    azimuth: 45,
    latitude: 42.346246551,
    longitude: -71.097768799,
  },
  {
    id: 4,
    azimuth: 127,
    latitude: 41.830183537,
    longitude: -87.634234768,
  },
  {
    id: 17,
    azimuth: 37,
    latitude: 41.947919347,
    longitude: -87.655827314,
  },
  {
    id: 2602,
    azimuth: 122,
    latitude: 39.097475189,
    longitude: -84.507040694,
  },
  {
    id: 5,
    azimuth: 0,
    latitude: 41.495547126,
    longitude: -81.685287955,
  },
  {
    id: 19,
    azimuth: 4,
    latitude: 39.755708522,
    longitude: -104.994201736,
  },
  {
    id: 2394,
    azimuth: 150,
    latitude: 42.339452099,
    longitude: -83.048975697,
  },
  {
    id: 4169,
    azimuth: 128,
    latitude: 25.778670385,
    longitude: -80.220050413,
  },
  {
    id: 2392,
    azimuth: 343,
    latitude: 29.756628163,
    longitude: -95.355147085,
  },
  {
    id: 7,
    azimuth: 46,
    latitude: 39.051247662,
    longitude: -94.480815828,
  },
  {
    id: 22,
    azimuth: 26,
    latitude: 34.073408641,
    longitude: -118.240236641,
  },
  {
    id: 32,
    azimuth: 129,
    latitude: 43.02842528,
    longitude: -87.971632868,
  },
  {
    id: 3312,
    azimuth: 90,
    latitude: 44.981715441,
    longitude: -93.278300252,
  },
  {
    id: 3313,
    azimuth: 75,
    latitude: 40.829487926,
    longitude: -73.926951914,
  },
  {
    id: 3289,
    azimuth: 13,
    latitude: 40.756586333,
    longitude: -73.846026348,
  },
  {
    id: 10,
    azimuth: 55,
    latitude: 37.751323556,
    longitude: -122.201083968,
  },
  {
    id: 2681,
    azimuth: 9,
    latitude: 39.905574802,
    longitude: -75.166595693,
  },
  {
    id: 31,
    azimuth: 116,
    latitude: 40.447061296,
    longitude: -80.006180963,
  },
  {
    id: 2680,
    azimuth: 0,
    latitude: 32.707048786,
    longitude: -117.157071534,
  },
  {
    id: 680,
    azimuth: 49,
    latitude: 47.591117866,
    longitude: -122.332907477,
  },
  {
    id: 2395,
    azimuth: 85,
    latitude: 37.778365552,
    longitude: -122.389915665,
  },
  {
    id: 2889,
    azimuth: 62,
    latitude: 38.622409365,
    longitude: -90.193389213,
  },
  /**
   * Commented out Tropicana so it
   * defaults to night/indoor lighting
   * {
   *  id: 12,
   *  azimuth: 359,
   *  latitude: 27.767597108,
   *  longitude: -82.653876767,
   * },
   */
  {
    id: 13,
    azimuth: 30,
    latitude: 32.747028748,
    longitude: -97.084508251,
  },
  {
    id: 14,
    azimuth: 345,
    latitude: 43.641158646,
    longitude: -79.389025685,
  },
  {
    id: 3309,
    azimuth: 28,
    latitude: 38.8725318,
    longitude: -77.0077778,
  },
  {
    id: 4249,
    azimuth: 72,
    latitude: 33.545238255,
    longitude: -111.885528922,
  },
  {
    id: 2756,
    azimuth: 157,
    latitude: 42.880754745,
    longitude: -78.873937602,
  },
  {
    id: 2536,
    azimuth: 138,
    latitude: 28.004018505,
    longitude: -82.7869625,
  },
];
